import { render, staticRenderFns } from "./LoginJWT.vue?vue&type=template&id=85a83dc0"
import script from "./LoginJWT.vue?vue&type=script&lang=js"
export * from "./LoginJWT.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports